"use client";
import { ReactNode, useEffect } from "react";
import { fetchMaintenanceConfig } from "@/util/maintenance";
import useConfig from "@/hooks/useConfig";
import { useQuery } from '@tanstack/react-query';

export default function MaintenanceGuard({ children }: { children: ReactNode }) {
    const { cmsBaseUrl, cmsAppId, cmsContentType } = useConfig();

    const { data, isLoading, isError } = useQuery({
        queryKey: ["maintenance", cmsAppId, cmsContentType],
        queryFn: () =>
            fetchMaintenanceConfig(cmsBaseUrl, cmsAppId, cmsContentType),
        retry: 2,
    });

    useEffect(() => {
        if (data?.maintenance_page_toggle) {
            const url = data.maintenance_page_redirect;
            try {
                new URL(url);
                window.location.replace(url);
            } catch {
                console.error("Invalid maintenance URL:", url);
            }
        }
    }, [data]);

    if (isLoading || isError || data?.maintenance_page_toggle) {
        return null;
    }

    return <>{children}</>;
}
